var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 448 512",
    width: 15,
    height: 15,
    fill: "#6148f6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 32H64C28.65 32 0 60.66 0 96v320c0 35.34 28.65 64 64 64h320c35.35 0 64-28.66 64-64V96C448 60.66 419.3 32 384 32zM319.1 280h-72V352c0 13.2-10.8 24-23.1 24c-13.2 0-24-10.8-24-24V280H127.1C114.8 280 103.1 269.2 103.1 256c0-13.2 10.8-24 24-24h71.1V160c0-13.2 10.8-24 24-24c13.2 0 23.1 10.8 23.1 24v72h72c13.2 0 23.1 10.8 23.1 24C343.1 269.2 333.2 280 319.1 280z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBox);
export default __webpack_public_path__ + "static/media/plus_box.94edf2be7efd693ee7e2be09a9b16bab.svg";
export { ForwardRef as ReactComponent };